<script lang='ts'>

	import type { TeaserContent } from '../../../domain/teaser/TeaserContent.ts';
	import { toSignUpSheet } from '../../../domain/SheetData.ts';
	import { trackClick, trackSeen, trackView } from '../../../services/tracking/TeaserTracking.ts';
	import { onMount } from 'svelte';
	import TrackingService from '../../../services/tracking/TrackingService.ts';
	import { onViewport } from '../../../services/tracking/IntersectionObserver';
	import { TeaserType } from '../../../domain/teaser/TeaserType.ts';

	let { teaserContent }: {
		teaserContent: TeaserContent,
	} = $props();

	const teaserType = TeaserType.NON_UP_PLUS_BOOSTER_TEASER;
	let teaser: Element;
	const teaserSize = 'MediaObject75';

	let headline = $state(teaserContent.heading);
	const signUpSheetData: string = getSheetData();

	function getSheetData() {
		return JSON.stringify(toSignUpSheet(teaserType, teaserContent, undefined));
	}

	let trackingService: TrackingService;

	onMount(() => {
		trackingService = new TrackingService();

		trackClick(trackingService, teaser, teaserContent, teaserType, teaserSize);
		trackView(trackingService, teaser, teaserContent, teaserType, teaserSize);
	});
</script>

<div bind:this={teaser}
	data-oc-sheet-v1-create={signUpSheetData}
	data-testid="non-up-plus-booster-teaser-detailView-container"
	id="up-combined-info-teaser-container"
	onenterViewport={() => trackSeen(trackingService)}
	use:onViewport>
	<oc-media-object-card-v2
		data-testid="to-non-up-plus-booster-teaser-card"
		variant="ambient-image"
		style="--background-color: #FFD7F5;"
		size="75"
		elevation-level="canvas"
	>
		<picture slot="img">
			<img
				loading="eager"
				src="https:/*                                                                                                                       */
				aria-hidden="true"
				alt="Gift illustration"
				style="background-color: #FFFFFF;"
			/>
		</picture>
		<button aria-label="oc-auto"></button>
		<div id="headline" slot="headline">{headline}</div>
		<div id="subline" slot="subline">{teaserContent?.subheading}</div>
	</oc-media-object-card-v2>
</div>
